// parallax.js - Handles image and background parallax offsets

export function initParallax() {
  const els = document.querySelectorAll('[data-parallax]');
  if (!els.length) return;
  const coarseNoHover = window.matchMedia('(pointer:coarse) and (hover:none)').matches;

  function update() {
    els.forEach(img => {
      const wrap = img.parentElement;
      const rect = wrap.getBoundingClientRect();
      const viewH = window.innerHeight;
      const delta = (rect.top + rect.height / 2 - viewH / 2);
      const speed = parseFloat(img.dataset.parallax) || 0.15;
      img.style.transform = `translateY(${delta * speed}px)`;
    });
  }

  if (!coarseNoHover) {
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
}

export function initPlatformBgParallax() {
  const section = document.getElementById('projekt');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const desktopBg = document.getElementById('parallax-bg-desktop');
  if (!desktopBg) return;

  const AMPLITUDE = 160;
  let ticking = false;

  function update() {
    const rect = section.getBoundingClientRect();
    const viewH = window.innerHeight;
    const raw = (viewH - rect.top) / (viewH + rect.height);
    const t = Math.max(0, Math.min(1, raw));
    const offset = ((t - 0.5) * AMPLITUDE).toFixed(2);
    desktopBg.style.transform = `translateY(${offset}px)`;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  update();
}
// 
